import { isTruthy } from "@dashboard/library";

import { useCallDurationRule } from "@/hooks/useCallDurationRule/useCallDurationRule";

import { useCall } from "@/hooks/useCall/useCall";

import { FEATURE_NAME } from "@/components/LicenseGuard/LicenseGuard.constant";
import { useHasLicenseAccess } from "@/components/LicenseGuard/useHasLicenseAccess";

export function useTabsRules() {
  const { call } = useCall();

  const hasEvaluationTabAccess = useHasLicenseAccess({
    feature: FEATURE_NAME.EVALUATION_TAB_ACCESS,
  });
  const { isCallDurationLow } = useCallDurationRule();

  const isExternalCall =
    call?.from?.agentId === undefined && call?.to?.agentId === undefined;

  const shouldDisableInsightsTab =
    isCallDurationLow ||
    call?.type === "voicemail" ||
    call?.transcription?.status !== "available";

  const shouldDisableEvaluationTab = !call?.transcription;

  const shouldHideEvaluationTab = [
    isExternalCall,
    !hasEvaluationTabAccess,
    call?.type === "voicemail",
  ].some(isTruthy);

  const shouldHideInsightsTab = call?.type === "voicemail";

  return {
    shouldDisableInsightsTab,
    shouldDisableEvaluationTab,
    shouldHideEvaluationTab,
    shouldHideInsightsTab,
  };
}
